// Res Images
import Res1 from './images/Res/Res1.jpeg'
import Res2 from './images/Res/Res2.jpeg'
import ResMain from './images/Res/ResMain.jpg'
// Elec Images
import ElecMain from './images/Elec/ElecMain.jpg'
import Elec1 from './images/Elec/Elec1.jpeg'
import Elec2 from './images/Elec/Elec2.jpeg'
import Elec3 from './images/Elec/Elec3.jpg'
import Elec4 from './images/Elec/Elec4.jpg'
import Elec5 from './images/Elec/Elec5.jpg'
import Elec6 from './images/Elec/Elec6.jpeg'
import Elec7 from './images/Elec/Elec7.jpeg'
import Elec8 from './images/Elec/Elec8.jpeg'
import Elec9 from './images/Elec/Elec9.jpeg'

// Elec Images
import MechMain from './images/Mech/MainMech.jpg'
import Mech1 from './images/Mech/Mech1.jpeg'
import Mech2 from './images/Mech/Mech2.jpeg'
import Mech3 from './images/Mech/Mech3.jpeg'
import Mech4 from './images/Mech/Mech4.jpeg'
import Mech5 from './images/Mech/Mech5.jpg'
import Mech6 from './images/Mech/Mech6.jpg'
import Mech7 from './images/Mech/Mech7.jpeg'
import Mech8 from './images/Mech/Mech8.jpeg'
// Pharm Images
import PharmMain from './images/Pharm/PharmMain.jpg'
import Pharm1 from './images/Pharm/Pharm1.jpeg'
import Pharm2 from './images/Pharm/Pharm2.jpeg'
import Pharm3 from './images/Pharm/Pharm3.jpeg'
import Pharm4 from './images/Pharm/Pharm4.jpeg'
import Pharm5 from './images/Pharm/Pharm5.jpeg'
// Gas Images
import GasMain from './images/Gas/GasMain.jpg'
import Gas1 from './images/Gas/Gas1.jpeg'
import Gas2 from './images/Gas/Gas2.jpeg'
import Gas3 from './images/Gas/Gas3.jpeg'
import Gas4 from './images/Gas/Gas4.jpeg'
import Gas5 from './images/Gas/Gas5.jpeg'
import Gas6 from './images/Gas/Gas6.jpeg'
// Warehouses & Factories
import WarehouseMain from './images/Ware&Fac/WareMain.jpg'
import W1 from './images/Ware&Fac/W1.jpeg'
import W2 from './images/Ware&Fac/W2.jpeg'
import W3 from './images/Ware&Fac/W3.jpeg'
import W4 from './images/Ware&Fac/W4.jpeg'
import W5 from './images/Ware&Fac/W5.jpeg'
import W6 from './images/Ware&Fac/W6.jpeg'
import W7 from './images/Ware&Fac/W7.jpeg'
import W8 from './images/Ware&Fac/W8.jpeg'
export const Projects = [
    {
      title: 'Res',
      mainImage: ResMain,
      images: [Res1, Res2],
      id: 1,
      url: '1'
    },
    {
      title: 'Electric',
      mainImage: ElecMain,
      images: [Elec1, Elec2, Elec3, Elec4, Elec5, Elec6, Elec7, Elec8, Elec9],
      id: 2,
      url: '2'
    },
    {
      title: 'Mechanic',
      mainImage: MechMain,
      images: [Mech1, Mech2, Mech3, Mech4, Mech5, Mech6, MechMain, Mech7, Mech8],
      id: 3,
      url: '3'
    },
    {
      title: 'Pharma',
      mainImage: PharmMain,
      images: [Pharm1, Pharm2, Pharm3, Pharm4, Pharm5],
      id: 4,
      url: '4'
    },
    {
        title: 'GasStations',
        mainImage: GasMain,
        images: [Gas1, Gas2, Gas3, Gas4, Gas5, Gas6],
        id: 5,
        url: '5'
    },
    {
        title: 'Warehouses',
        mainImage: WarehouseMain,
        images: [W1, W2, W3, W4, W5, W6, W7, W8],
        id: 6,
        url: '6'
    },
  ];